<div><app-titlebar #titlebar></app-titlebar></div>
<app-hindsight-settings />
